export default __webpack_public_path__ + "static/media/step7.f9649ca3.png";